const common = {
	duration: '0.35s',

	fontFamily: `'Open Sans', sans-serif`,
	fontSize: '20px',
	lineHeight: '1.5',

	contentWidth: '1160px',
	tabletContentWidth: '940px',
	verticalTabletContentWidth: '624px',
	phoneContentWidth: '460px',
	phoneXsContentWidth: '294px',
	headerHeight: '65px',

	notebook: 'max-width: 1439px',
	tablet: 'max-width: 1199px',
	horizontalTablet: 'max-width: 1023px',
	verticalTablet: 'max-width: 959px',
	phone: 'max-width: 639px',
	phoneXs: 'max-width: 479px',
	screenMobile: '360px',
	screenSm: '576px',
	screenMd: '768px',
	screenXl: '1200px',
	screenXxxl: '1920px',
	screenSmMax: `575px`,
	screenMdMax: '767px',
	screenXlMax: `1199px`,
}

const color = {
	white: '#fff',
	bgColor: '#fff',
	blackColor: '#262626',
	linkColor: '#19bb4f',
	grayColor: '#f5f5f5',
	grayTextColor: '#878787',
	specialBlockTitle: '#959595',
	specialPrice: '#19bb4f',
	deepBlack: '#000000',
}

const palette = {
	gray: {
		1: '#F4F4F6',
		2: '#EFEFF2',
		3: '#E3E3E7',
		4: '#CACFD9',
		5: '#89909D',
		6: '#626570',
		7: '#434651',
		8: '#373A44',
		9: '#202227',
	},
	arctic: {
		1: '#E7FFFF',
		2: '#BEF8EC',
		3: '#94F1DA',
		4: '#6BEAC7',
		5: '#42E3B4',
		6: '#1EA666',
		7: '#21A19A',
		8: '#107F8C',
		9: '#005E7F',
	},
	emerald: {
		1: '#EEF7F2',
		2: '#CFEDD8',
		3: '#97DDAC',
		4: '#6CD89F',
		5: '#21BA72',
		6: '#1EA666',
		7: '#0C8151',
		8: '#036541',
		9: '#02332A',
	},
	pink: {
		1: '#FFE5F3',
		2: '#FEB3D2',
		3: '#FE87B7',
		4: '#FF3C8A',
		5: '#FF0066',
		6: '#DA005E',
		7: '#B40057',
		8: '#8F0051',
		9: '#69004A',
	},
	blue: {
		1: '#E8F5FF',
		2: '#BBE0FE',
		3: '#89C7FF',
		4: '#5AB0FF',
		5: '#0087CD',
		6: '#1164C0',
		7: '#184EA1',
		8: '#203883',
		9: '#13224E',
	},
	gold: {
		1: '#FFF8E5',
		2: '#FFE6B6',
		3: '#FFD685',
		4: '#FFCC47',
		5: '#FAAD14',
		6: '#DD6F00',
		7: '#BD4F00',
		8: '#A53B00',
		9: '#8F2B00',
	},
}

const fontFamily = {
	SBSansText: "'SBSansText', 'Open Sans', sans-serif",
	SBSansInterface: "'SBSansInterface', 'Open Sans', sans-serif",
}

const fontWeight = {
	SBSansText: {
		thin: 250,
		light: 300,
		regular: 400,
		medium: 500,
		semibold: 600,
		bold: 700,
		heavy: 900,
	},
	SBSansInterface: {
		light: 300,
		regular: 400,
		semibold: 600,
		bold: 700,
	},
}

export const styleConstant = {
	common,
	color,
	fontFamily,
	fontWeight,
	palette,
}
